import { css } from 'lit';

export default css`
  :host {
    align-items: center;
    color: var(--sl-color-foreground-bold);
    display: inline-flex;
    font-weight: var(--sl-text-typeset-fontWeight-demibold);
  }

  .optional,
  .required {
    margin-inline-start: var(--sl-size-050);
  }
`;
